import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import Buefy from 'buefy';
import VueSocketIOExt from 'vue-socket.io-extended';
import '@/utils/api/interceptors';
import '@/utils/filters';
import '@/utils/directives';
import '@mdi/font/css/materialdesignicons.css';
import '@/assets/scss/app.scss';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import VueMq from 'vue-mq';
import { getSocket } from '@/utils/socketConnection';
import VueTagManager from 'vue-tag-manager';
import VueObserveVisibility from 'vue-observe-visibility';
import i18n from './i18n';

Vue.use(VueTagManager, {
  gtmId: 'GTM-KN7LT27',
});

Vue.use(VueObserveVisibility);

Vue.use(VueMq, {
  breakpoints: {
    mobile: 768,
    desktop: 1024,
    widescreen: 1216,
    fullhd: 1408,
  },
});
Vue.use(Buefy);
Vue.use(VueSocketIOExt, getSocket(), { store });

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  created() {
    import('@/vee-validate');
  },
  render: h => h(App),
}).$mount('#app');
